<template>
  <div>
    <b-modal
      v-show="!modalLoads"
      id="modal-case"
      ref="my-modal"
      cancel-variant="outline-secondary"
      :ok-variant="bVarient"
      :ok-title="bTitle"
      cancel-title="Close"
      centered
      :title="$t('DEBTIA_EDIT_CASE_DETAILS')"
      size="lg"
      @ok="submitHandler"
    >
      <b-overlay
        id="overlay-background"
        :show="modalLoads === true"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-alert
          variant="danger"
          :show="alertErrors.length > 0"
          class="mb-1"
        >
          <div
            v-for="(row, index) in alertErrors"
            :key="index"
            class="alert-body"
          >
            <feather-icon

              icon="InfoIcon"
              class="mr-50"
            />
            {{ row }}
          </div>
        </b-alert>
        <b-form>
          <validation-observer
            ref="manageCaseForm"
            tag="form"
          >
            <b-row>
              <b-col
                v-if="selectedState === 'pause'"
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_CASE_PAUSE_DATE')"
                  label-for="cost"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="pause_date"
                    rules="required"
                  >
                    <b-form-datepicker
                      id="pause_date"
                      v-model="caseData.pause_date"
                      placeholder="caseData.pause_date"
                      :min="min"
                      :max="max"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                v-if="selectedState === 'pause'"
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_CASE_RECIEVE_REMINDER')"
                  label-for="receive_reminder"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="receive_reminder"
                    rules="required"
                  >
                    <b-form-checkbox
                      id="receive-reminder"
                      v-model="selected"
                      name="receive_reminder"
                    >
                      Receive reminder
                    </b-form-checkbox>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                v-if="selectedState === 'terminate' && caseData.remaining_debt_amount >= 0.1"
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_CASE_COST')"
                  label-for="is_cost"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="is_cost"
                    rules="required"
                  >
                    <b-form-checkbox
                      id="is-cost"
                      v-model="confirmCost"
                      name="is_cost"
                    >
                      Terminate with cost? ( Amount: {{ caseData.remaining_debt_amount }})
                      <!-- need to add amount -->
                    </b-form-checkbox>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                v-if="selectedState === 'terminate'"
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_CASE_REASON')"
                  label-for="reason"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="reason"
                    rules="required"
                  >
                    <v-select
                      v-model="caseData.reason"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="reasonOptions"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="reason"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                v-if="selectedState !== 'resume'"
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_CASE_DESCRIPTION')"
                  label-for="description"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="description"
                    rules="required"
                  >
                    <b-form-textarea
                      id="textarea-rows"
                      v-model="caseData.description"
                      :placeholder="$t('DEBTIA_CASE_DESCRIPTION')"
                      rows="8"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </validation-observer>
        </b-form>
        <b-row v-if="selectedState === 'resume'">
          <b-col sm="12">
            <b-form-group
              :label="$t('DEBTIA_CONFIRM_RESUME_STATE')"
              label-for="confirm_resume_state"
              class="mb-2"
            >
              <validation-provider
                #default="{ errors }"
                name="confirm_resume_state"
                rules="required"
              >
                <b-form-checkbox
                  id="confirm-resume-state"
                  v-model="confirmResumeState"
                  name="confirm_resume_state"
                >
                  Confirm resume state
                </b-form-checkbox>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col sm="12">
            <b-form-group
              :label="$t('DEBTIA_CASE_EMPLOYEE_NAME')"
              label-for="employee_name"
              class="mb-2"
            >
              <b-form-input
                id="employee-name"
                v-model="caseData.employee_name"
                :readonly="selectedState === 'resume'"
              />
            </b-form-group>
          </b-col>
          <b-col sm="12">
            <b-form-group
              :label="$t('DEBTIA_CASE_PAUSE_DATE')"
              label-for="cost"
              class="mb-2"
            >
              <b-form-datepicker
                id="pause_date"
                v-model="caseData.pause_date"
                :readonly="selectedState === 'resume'"
              />
            </b-form-group>
          </b-col>
          <b-col sm="12">
            <b-form-group
              :label="$t('DEBTIA_CASE_DESCRIPTION')"
              label-for="description"
              class="mb-2"
            >
              <b-form-textarea
                id="textarea-rows"
                v-model="caseData.description"
                rows="8"
                :readonly="selectedState === 'resume'"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BOverlay, BFormCheckbox, BFormTextarea, BFormDatepicker, BAlert,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import { required } from '@validations'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import constants from '@/app-configs/constants'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
    vSelect,
    BFormCheckbox,
    BFormDatepicker,
    BFormTextarea,
    BAlert,
  },
  directives: {
    Ripple,
  },
  props: {
    caseData: {
      type: Object,
      required: true,
    },
    selectedState: {
      type: String,
      required: true,
    },
    bTitle: {
      type: String,
      required: true,
    },
    bVarient: {
      type: String,
      required: true,
    },
    reloadMethod: {
      type: Function,
      required: true,
    },
    modalLoads: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    // 15th two months prior
    const minDate = new Date(today)
    minDate.setMonth(minDate.getMonth())
    // minDate.setDate(15)
    const maxDate = new Date(today)
    maxDate.setMonth(maxDate.getMonth())
    maxDate.setDate(now.getDate() + 15)
    return {
      snowOption: {
        theme: 'snow',
      },
      loader: false,
      details: [],
      selected: true,
      confirmCost: false,
      confirmResumeState: true,
      required,
      state: '',
      user_type: JSON.parse(localStorage.getItem('userData')).data.name,
      modalLoader: true,
      useCaseData: { ...this.caseData },
      alertErrors: [],
      min: minDate,
      max: maxDate,
      reasonOptions: [],
      requestArgs: [
        { request: '/get-reason-options', param: 'reasonOptions' },
      ],
      args: [{ label: 'test', value: 't' }],
    }
  },
  setup() {
    // const reasonOptions = []
    const reasonOptionsArgs = []
    /* const requestArgs = [
      { request: '/get-reason-options', param: 'reasonOptions' },
    ] */
    return {
      // reasonOptions,
      reasonOptionsArgs,
      // requestArgs,
    }
  },
  watch: {
    caseData: {
      deep: true,
      handler(newValue) {
        console.log('Selected users changed', newValue)
        this.details = { ...this.caseData }
      },
    },
    selected: {
      deep: true,
      handler(newValue) {
        console.log('Selected settings changed', newValue)
      },
    },
    confirmCost: {
      deep: true,
      handler(newValue) {
        console.log('Selected confirmCost changed', newValue)
      },
    },
    confirmResumeState: {
      deep: true,
      handler(newValue) {
        console.log('Selected sate changed', newValue)
      },
    },
  },
  created() {
    this.getReasons()
  },
  methods: {
    async getReasons() {
      try {
        await Promise.all(
          this.requestArgs
            .map(REQUEST => axios
              .get(REQUEST.request)
              .then(res => {
                if (REQUEST.param === 'reasonOptions') {
                  this.reasonOptions = [...res.data.data]
                }
              })),
        )
          .then(() => {
            this.loading = false
          })
      } catch (error) {
        console.log('options error', error)
      }
    },
    makeSuccessToast() {
      this.$bvToast.toast('Case Details have been successfully updated', {
        title: 'Success',
        variant: 'success',
        solid: false,
      })
    },
    submitHandler(evt) {
      evt.preventDefault()
      return new Promise((resolve, reject) => {
        if (this.confirmResumeState) {
          this.$refs.manageCaseForm.validate().then(success => {
            if (success) {
              this.loader = true
              // const url = `${constants.baseUrl}/update-debt-case`
              this.details.user_id = JSON.parse(localStorage.getItem('userData')).data.id
              this.details.state = this.selectedState
              this.details.receive_reminder = this.selected
              this.details.confirm_resume_state = this.confirmResumeState
              this.details.is_cost = this.confirmCost
              this.details.creditor_id = this.caseData.creditor_id
              this.details.employee_name = JSON.parse(localStorage.getItem('userData')).data.name
              const data = { ...this.details }
              axios.post('update-debt-case', data).then(response => {
                console.log('done', response)
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Success',
                    icon: 'CoffeeIcon',
                    variant: 'primary',
                    text: 'Case state has been updated successfully.',
                  },
                })
                this.loader = false
                this.$refs['my-modal'].hide()
                this.reloadMethod()
              }).catch(err => {
                if (err.response.data.message) {
                  this.alertErrors.push(err.response.data.message)
                }
              })
            } else {
              this.loading = false
              reject()
            }
          })
        }
      })
    },
    show() {
      this.$refs['my-modal'].show()
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
